import React, { useState } from "react";
import { useSelector } from "react-redux";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import AccessMasterCard from "./AccessMasterCard";
import CheckAndReturn from "../../utility/CheckAndReturn";

//FUNCTION
const AccessMaster = () => {
  //#region code
  const { user_id, is_super, permissions } = useSelector(
    (state) => state.GlobalVariables
  );
  const open = useSelector((state) => state.sideExpand.open);
  const [openDialog, setOpenDialog] = useState(true);

  const handleClickOpen = () => {
    setOpenDialog(!openDialog);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };
  //#endregion

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"ACCESS MASTER"}
        handlePopup={handleClickOpen}
        create={openDialog}
        hideAddButton={
          !CheckAndReturn.PermissionHandler("create-access-master", permissions)
        }
      />

      <AccessMasterCard handleClose={handleClose} open={openDialog} />
    </>
  );
};

export default AccessMaster;
